import React, { useEffect, useState } from 'react'
import { postAPI } from '../../app/api';
import { store, setStore } from '../../app/store';
import NotAuthorizedImg from "../../theme/assets/img/illustrations/page-misc-you-are-not-authorized.png";

export default function NotAuthorized() {
  return (
    <div class="container-xxl container-p-y text-center">
      <div class="misc-wrapper">
        <h2 class="mb-1 mx-2">You are not authorized!</h2>
        <p class="mb-4 mx-2">You do not have permission to view this page using the credentials that you have provided while login. <br /> Please contact your site administrator.</p>
        <a href="/" class="btn btn-primary mb-4 waves-effect waves-light">Back to Home</a>
        <div class="mt-4">
          <img src={NotAuthorizedImg} alt="page-misc-not-authorized" width="170" class="img-fluid" />
        </div>
      </div>
    </div>
  )
}
